import TailwindEditor from '@/components/editor/tailwind-editor'
import { PageTransition } from '@blogging/ui'
import { Suspense } from 'react'
import { useParams } from 'react-router-dom'

export function PostEditorPage() {
  const { siteId, id } = useParams()

  return (
    <PageTransition isLoading={false}>
      <Suspense fallback={<div>Loading editor...</div>}>
        <TailwindEditor
          siteId={siteId as string}
          initialPostId={id}
          type="post"
        />
      </Suspense>
    </PageTransition>
  )
}
